import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import dayjs from 'dayjs'
import 'dayjs/locale/es-mx';
import { Box } from '@mui/material'

const Fecha = ((props) => {
   return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es-mx">
      <Box sx={{ display: 'flex', gap: 2 }}>
        <DatePicker  
          slotProps={{ textField: { size: 'small' } }} 
          format='YYYY - MM - DD' 
          value={dayjs(props.fecha)} 
          onChange={e => props.setFecha(e)} 
          disablePast
        />
        <TimePicker  
          slotProps={{ textField: { size: 'small' } }} 
          format='HH:mm'
          value={dayjs(props.fecha)} 
          onChange={e => props.setFecha(e)} 
          ampm={false}
        />
      </Box>
    </LocalizationProvider>
  )
})
export default Fecha